module.exports = __webpack_public_path__ + "img/puberty-decal-21.332a69c8.png";